/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a.show-schedule[_ngcontent-%COMP%], a.show-schedule[_ngcontent-%COMP%]:hover, h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]{color:#0080ff}h4[_ngcontent-%COMP%]{font-size:3rem}h3[_ngcontent-%COMP%]{font-size:2rem;text-transform:uppercase}a.show-schedule[_ngcontent-%COMP%]{cursor:pointer}@media (max-width:403px),(min-width:510px) and (max-width:697px),(min-width:768px) and (max-width:992px){[_nghost-%COMP%]     p.live-class-type{font-size:.75rem;padding:.125rem 0}[_nghost-%COMP%]     p.live-class-type i:before{padding-left:0;font-size:.5rem}}"];
export { styles as styles };
//# sourceMappingURL=live-class-week-schedule.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-week-schedule/live-class-week-schedule.component.scss.shim.ngstyle.js
// module id = 1554
// module chunks = 27 28 29